// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

const ezSelectorUrl = "/api/ces/schneider/products";

export type EzSelectorList = { productId: string; quantity: number }[];

export function postEzSelectorLines(productList: EzSelectorList) {
    return post<EzSelectorList, { lines: CartLineModel[] }>(ezSelectorUrl, productList);
}
